import React, { useEffect, useRef } from 'react';
import { ExporAllProducts, ExporAllRfq, ExporAllTrendingProducts } from '../../../../services/ProductService/AllProductList/AllProductServices';

export default function BulkExportAllServices({ onActiveTab }) {
    const hasExported = useRef(false); // Prevents duplicate execution

    const handleExportAllProducts = async () => {
        if (!onActiveTab || hasExported.current) return;

        hasExported.current = true; // Set flag to prevent duplicate execution

        try {
            let response;
            let fileName = '';

            if (onActiveTab === 'all') {
                response = await ExporAllProducts('GET', null, { responseType: 'blob' });
                fileName = 'AllProductsList.xlsx';
            } else if (onActiveTab === 'trending') {
                response = await ExporAllTrendingProducts('GET', null, { responseType: 'blob' });
                fileName = 'TrendingProductsList.xlsx';
            } else if (onActiveTab === 'highDemand') {
                response = await ExporAllRfq('GET', null, { responseType: 'blob' });
                fileName = 'RFQ-Datas.xlsx';
            }

            if (!response || !response.data || !(response.data instanceof Blob)) {
                console.error('Invalid response data:', response?.data);
                return;
            }

            // Create a blob and trigger download
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting file:', error);
        }
    };

    useEffect(() => {
        hasExported.current = false; // Reset flag when `onActiveTab` changes
        handleExportAllProducts();
    }, [onActiveTab]);

    return (
        <div>
            
        </div>
    );
}